import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Fido from '../../utils/Fido';
import Constants from '../../utils/Constants';
import DeepMerge from "../../utils/DeepMerge";
import AuthorizedUserContext from "../../utils/AuthorizedUserContext";
import ReportDataMasseuse from "../utils/ReportDataMasseuse";
import OverviewReportLayout from "../components/OverviewReportLayout";
import SparkChartReportItem from "../components/SparkChartReportItem";
import WebSearchReport from "../components/WebSearchReport";
import RecentPostsItem from "../components/RecentPostsItem";
import TopOffensivePeople from "../components/TopOffensivePeople";
import ChartClasses from "../components/ChartClasses";

class WebSearchOverviewReport extends Component {
	constructor(props, context) {
		super(props, context);

		this.sparkCardsFido = new Fido();
		this.graphFido = new Fido();
		this.activityFido = new Fido();
		this.senderFido = new Fido();
		this.recipientFido = new Fido();

		let {days} = this.props,
			filter = {
				source: "web_search",
				previousDays: days
			};

		this.state = {
			filter,
			defaultFilter: Object.assign({}, filter),

			totalImages: null,
			imagesAmountChange: null,
			imagesPercentageChange: null,
			postsAndImages: [],

			totalAlerts: null,
			alertsAmountChange: null,
			alertsPercentageChange: null,
			alerts: [],

			totalDiscussions: null,
			discussionsAmountChange: null,
			discussionsPercentageChange: null,
			discussions: [],

			webSearchTotalPosts: null,
			webSearchPostsAmountChange: null,
			webSearchPostsPercentageChange: null,
			webSearchPostsAndImages: [],

			totalAlertsViewed: null,
			alertsViewedAmountChange: null,
			alertsViewedPercentageChange: null,
			alertViews: [],

			alertRatio: null,
			ssiAlertRatio: null,
			
			sparkCardsFidoError: false,

			splolumnAlerts: null,
			splolumnWebSearch: null,
			splolumnFidoError: false,

			activities: null,
			recentFidoError: false,

			topSenders: null,
			sendersFidoError: false,

			topReceivers: null,
			recipientsFidoError: false
		};

		this.executeFilter = this.executeFilter.bind(this);
	}

	componentDidMount() {
		this.setupReport();
	}

	componentWillUnmount() {
		this.sparkCardsFido.dropIt();
		this.graphFido.dropIt();
		this.activityFido.dropIt();
		this.senderFido.dropIt();
		this.recipientFido.dropIt();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.search === "" && prevProps.location.search !== "") {
			let {filter} = this.state,
				{authenticatedUser} = this.props;

			filter.account = authenticatedUser.childAccounts.map(item => item.id);
			this.setState({
				filter: filter,
				defaultFilter: Object.assign({}, filter)
			});
		}
	}

	dropThem() {
		this.sparkCardsFido.dropIt();
		this.graphFido.dropIt();
		this.activityFido.dropIt();
		this.senderFido.dropIt();
		this.recipientFido.dropIt();
	}

	setupReport() {
		this.props.updateHeader({title: "Teams", primary: true});
	}

	loadData() {
		this.setState({
			postsAndImages: [],
			alerts: [],
			discussions: [],
			webSearchPostsAndImages: [],
			splolumnEmails: null,
			activities: null,
			topSenders: null,
			topReceivers: null
		}, () => {
			this.loadSparkData();
			this.loadWebSearchData();
			this.loadRecentActivityData();
			this.loadSenderOffensiveData();
			this.loadRecipientOffensiveData();
		});
	}

	async loadSparkData() {
		let data = await this.sparkCardsFido.fetch("/reports/web-search/spark", {query: this.state.filter})
			.catch(error => {
				this.setState({sparkCardsFidoError: true});
				return this.props.showSnackbar(error.message);
			});

		if (data) {
			this.setState(data);
		}
	}

	async loadWebSearchData(query) {
		let data = await this.graphFido.fetch("/reports/web-search/alerts-associations", {query: this.state.filter})
			.catch(error => {
				this.setState({splolumnFidoError: true});
				return this.props.showSnackbar(error.message);
			});

		if (data) {
			this.setState({
				splolumnWebSearch: data.webSearchAssociations,
				splolumnAlerts: data.alerts
			});
		}
	}

	async loadRecentActivityData() {
		let data = await this.activityFido.fetch("/activities", DeepMerge.merge(
			{query: {limit: 5}},
			{query: {source: Constants.SOURCES.WEB_SEARCH}},
			{query: {category: "alerts"}},
			{query: this.state.filter}
		))
			.catch(error => {
				this.setState({recentFidoError: true});
				return this.props.showSnackbar(error.message);
			});

		if (data) {
			this.setState(data);
		}
	}

	async loadSenderOffensiveData() {
		let data = await this.senderFido.fetch("/reports/web-search/top-senders", DeepMerge.merge(
			{query: {limit: 5}},
			{query: this.state.filter}
		))
			.catch(error => {
				this.setState({sendersFidoError: true});
				return this.props.showSnackbar(error.message);
			});

		if (data) {
			// TEMP
			//this.setState({topSenders: emailOverviewData.topSenders});
			this.setState(data);
		}
	}

	async loadRecipientOffensiveData() {
		let data = await this.recipientFido.fetch("/reports/web-search/top-receivers", DeepMerge.merge(
			{query: {limit: 5}},
			{query: this.state.filter}
		))
			.catch(error => {
				this.setState({recipientsFidoError: true});
				return this.props.showSnackbar(error.message);
			});

		if (data) {
			// TEMP
			//this.setState({topReceivers: emailOverviewData.topReceivers});
			this.setState(data);
		}
	}

	getFilterOpts(filterObj) {
		let opts,
			{filter} = this.state;

		if (!filterObj.previousDays) {
			delete filter.previousDays;
		}

		Number(filter.previousDays[0]);

		opts = Object.assign(filter, filterObj);

		return opts;
	}

	executeFilter(filterObj) {
		let opts = this.getFilterOpts(filterObj);
		this.dropThem();
		delete opts.source;
		this.setState({filter: opts}, this.loadData);
	}

	render() {
		const numFormatter = new Intl.NumberFormat("en-US", {maximumFractionDigits: 2});
		let {history, location, days} = this.props,
			{filter,
				webSearchPostsAndImages,
				webSearchTotalPosts,
				webSearchPostsAmountChange,
				webSearchPostsPercentageChange,
				sparkCardsFidoError,
				splolumnAlerts, splolumnWebSearch, splolumnFidoError,
				activities, recentFidoError,
				topSenders, sendersFidoError,
				topReceivers, recipientsFidoError,
				totalImages, imagesAmountChange, imagesPercentageChange, postsAndImages,
				totalAlerts, alertsAmountChange, alertsPercentageChange,
				totalAlertsViewed, alertsViewedPercentageChange, alertsViewedAmountChange,
				alertViews, alertRatio, ssiAlertRatio,
				alerts, totalDiscussions, discussionsAmountChange, discussionsPercentageChange, discussions} = this.state,
			previousDays = Number(filter.previousDays || days),
			recentAlertsTitle = (
				<div>
					<FontAwesomeIcon title="recent alerts" icon={["fas", "wifi"]} transform={{ rotate: 90 }} /> Most Recent Alerts
				</div>
			);

		let sparkCards = [
			<ReportDataMasseuse
				key={"spark0"}
				dataConfig={[{data: postsAndImages, key: "period", valueKey: "associations"}]}
				render={data =>
					<SparkChartReportItem
						fidoError={sparkCardsFidoError}
						title="Associated Posts"
						value={webSearchTotalPosts}
						data={data[0]}
						change={webSearchPostsAmountChange}
						previousDays={previousDays}
						percentChange={webSearchPostsPercentageChange} />
				} />,
			<ReportDataMasseuse
				key={"spark1"}
				dataConfig={[{data: postsAndImages, key: "period", valueKey: "images"}]}
				render={data =>
					<SparkChartReportItem
						fidoError={sparkCardsFidoError}
						title="Images Scanned"
						value={totalImages}
						data={data[0]}
						change={imagesAmountChange}
						previousDays={previousDays}
						percentChange={imagesPercentageChange} />
				} />,
			<ReportDataMasseuse
				key={"spark2"}
				dataConfig={[{data: alerts, key: "period", valueKey: "alerts"}]}
				render={data =>
					<SparkChartReportItem
						invertChevron
						fidoError={sparkCardsFidoError}
						title="Alerts"
						value={totalAlerts}
						data={data[0]}
						change={alertsAmountChange}
						previousDays={previousDays}
						percentChange={alertsPercentageChange} />
				} />,
			<ReportDataMasseuse
				key={"spark3"}
				dataConfig={[{data: alerts, key: "period", valueKey: "alert_ratio"}]}
				render={data =>
					<SparkChartReportItem
						invertChevron
						valueIsPercentage
						excludePerDay
						fidoError={sparkCardsFidoError}
						title="Alert Ratio"
						value={alertRatio}
						data={data[0]}
						caption={`Benchmark: ${numFormatter.format(ssiAlertRatio)}%`}
						forceGreen={alertRatio < ssiAlertRatio} />
				} />,
			<ReportDataMasseuse
				key={"spark4"}
				dataConfig={[{data: alertViews, key: "period", valueKey: "alerts_viewed"}]}
				render={data =>
					<SparkChartReportItem
						fidoError={sparkCardsFidoError}
						title="Alerts Viewed"
						value={totalAlertsViewed}
						data={data[0]}
						change={alertsViewedAmountChange}
						percentChange={alertsViewedPercentageChange}
						forceGreen={alertsViewedPercentageChange === 100}
						previousDays={previousDays} />
				} />,	
			<ReportDataMasseuse
				key={"spark5"}
				dataConfig={[{data: discussions, key: "period", valueKey: "alerts"}]}
				render={data =>
					<SparkChartReportItem
						fidoError={sparkCardsFidoError}
						title="Discussions"
						value={totalDiscussions}
						data={data[0]}
						change={discussionsAmountChange}
						previousDays={previousDays}
						percentChange={discussionsPercentageChange} />
				} />
		];

		return (
			<OverviewReportLayout
				location={location}
				sparkCards={sparkCards}
				previousDays={previousDays}
				filterCallback={this.executeFilter}
				sparkCardSizing={{xs: 12, sm: 3, md: 3, lg: 3, xl: 2}}>
				<ChartClasses
					fullWidth
					render={props =>
						<WebSearchReport
							{...props}
							webSearch={splolumnWebSearch}
							alerts={splolumnAlerts}
							previousDays={previousDays}
							fidoError={splolumnFidoError} />
					}/>
				<TopOffensivePeople
					history={history}
					people={topSenders}
					nameKey="user"
					fidoError={sendersFidoError}
					title="Authors of the Most Alerts"
					buttonText="view all alerts"
					noDataMessage="There are authors for this time period."
					buttonClickHandler={() => history.push("/inbox")} />
				<TopOffensivePeople
					history={history}
					people={topReceivers}
					nameKey="user"
					fidoError={recipientsFidoError}
					title="Top Search Providers"
					buttonText="view all alerts"
					noDataMessage="There are no recipients for this time period."
					buttonClickHandler={() => history.push("/inbox")} />
				<RecentPostsItem
					activities={activities}
					history={history}
					fidoError={recentFidoError}
					title={recentAlertsTitle}
					itemClickPath="/inbox"
					buttonText="view all alerts"
					noDataMessage="There are no recent alerts for this time period."
					buttonClickHandler={() => history.push("/inbox")} />
			</OverviewReportLayout>
		);
	}
}

WebSearchOverviewReport.defaultProps = {
	days: 30
};

WebSearchOverviewReport.propTypes = {
	location: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	days: PropTypes.number,
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
	authenticatedUser: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired
};

// eslint error
const dNameFunc = (props, ref) => (
	<AuthorizedUserContext.Consumer>
		{authenticatedUser => <WebSearchOverviewReport {...props} authenticatedUser={authenticatedUser} ref={ref} />}
	</AuthorizedUserContext.Consumer>
);
dNameFunc.displayName = "WebSearchOverviewReport";

export default (React.forwardRef(dNameFunc));